var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSession(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9C1.5 7.54131 2.07946 6.14236 3.11091 5.11091C4.14236 4.07946 5.54131 3.5 7 3.5C7.13261 3.5 7.25979 3.55268 7.35355 3.64645C7.44732 3.74021 7.5 3.86739 7.5 4V8.5H12C12.1326 8.5 12.2598 8.55268 12.3536 8.64645C12.4473 8.74022 12.5 8.86739 12.5 9C12.5 10.4587 11.9205 11.8576 10.8891 12.8891C9.85764 13.9205 8.45869 14.5 7 14.5C5.54131 14.5 4.14236 13.9205 3.11091 12.8891C2.07946 11.8576 1.5 10.4587 1.5 9Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2C8.5 1.86739 8.55268 1.74021 8.64645 1.64645C8.74022 1.55268 8.86739 1.5 9 1.5C10.4587 1.5 11.8576 2.07946 12.8891 3.11091C13.9205 4.14236 14.5 5.54131 14.5 7C14.5 7.13261 14.4473 7.25979 14.3536 7.35355C14.2598 7.44732 14.1326 7.5 14 7.5H9C8.86739 7.5 8.74022 7.44732 8.64645 7.35355C8.55268 7.25979 8.5 7.13261 8.5 7V2Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession);
export default __webpack_public_path__ + "static/media/session.28e5e537c73cf634a76c088f73abbdea.svg";
export { ForwardRef as ReactComponent };